<template lang="html">
  <v-input
    label="Sideorders"
    :value="value"
    :rules="rules"
    class="sideorder-input"
    :disabled="disabled"
  >
    <div class="flex-grow-1 pt-1 pb-2">
      <draggable
        :value="value"
        @input="onInput"
        ghost-class="product__sideorder-ghost"
        draggable=".sideorder-item"
        handle=".handle"
        class="row row--dense"
      >
        <!-- selected chips -->
        <v-col
          v-for="itemId in value"
          :key="itemId"
          class="sideorder-item"
          cols="auto"
        >
          <v-chip
            close
            close-icon="mdi-close"
            :disabled="disabled"
            @click:close="removeItem(itemId)"
          >
            <div class="d-flex align-center">
              <v-icon class="handle">mdi-drag</v-icon>
              <span>{{getItemValue(itemId, sideOrders, 'name')}}</span>
            </div>
          </v-chip>
        </v-col>

        <!-- add button -->
        <v-col cols="auto">
          <v-dialog
            v-model="dialog"
            scrollable
            max-width="400px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                color="primary"
                link
                :disabled="disabled"
                v-bind="attrs"
                v-on="on"
              >
                <div class="d-flex align-center">
                  <v-icon left>mdi-plus</v-icon>
                  <span>ADD</span>
                </div>
              </v-chip>
            </template>

            <v-card>
              <v-card-title>Select Sideorders</v-card-title>
              <v-card-text>
                <v-list-item
                  v-for="sideOrder in sortedSideOrders"
                  :key="sideOrder.id"
                  @click="value.indexOf(sideOrder.id) == -1 ? addItem(sideOrder.id) : removeItem(sideOrder.id)"
                >
                  <v-list-item-action>
                    <v-checkbox :input-value="value.indexOf(sideOrder.id) != -1"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{sideOrder.name}}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{sideOrder.price}}:-
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn
                  color="primary"
                  text
                  @click="dialog = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </draggable>
    </div>
  </v-input>
</template>

<script>
import draggable from 'vuedraggable'
import {getItemById} from '@dynapp/wc-api-generic';

export default {
  props: {
    value: {
      default: () => []
    },
    sideOrders: {
      default: () => []
    },
    rules: {},
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  computed: {
    sortedSideOrders() {
      var result = this.sideOrders.slice(0);
      result.sort((a, b) => {
        if (a.name > b.name) {
          return 1;
        } else if (a.name > b.name) {
          return -1;
        }
        return 0;
      });
      return result;
    }
  },
  methods: {
    onInput(value) {
      this.$emit('input', value);
    },
    addItem(item) {
      var newValue = this.value.slice(0);
      newValue.push(item);
      this.onInput(newValue);
    },
    removeItem(item) {
      var newValue = this.value.slice(0);
      var index = newValue.indexOf(item);
      newValue.splice(index, 1);
      this.onInput(newValue);
    },
    getItemValue(itemId, items, key) {
      var item = getItemById(items, itemId);
      if (!item) {
        return null;
      }
      return item[key];
    }
  },
  components: {
    draggable
  }
}
</script>

<style lang="scss" scoped>
.product__sideorder-ghost .v-chip {
  background-color: var(--v-secondary-base)!important;
}
.handle {
  cursor: grab;
}
.sideorder-input {
  &:deep .v-input__slot {
   display: block;
  }

  &:deep .v-input__control > .v-input__slot:before {
    bottom: -1px;
    content: "";
    left: 0;
    position: absolute;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;

    border-color: rgba(0, 0, 0, 0.42);
    border-style: solid;
    border-width: thin 0 0 0;
  }
  &:deep:hover .v-input__slot:before {
    border-color: rgba(0, 0, 0, 0.87);
  }
}
</style>
